import React from "react";
import ButtonList from "../../../components/ButtonList";
import LinkButton from "../../../components/LinkButton";

import styles from "./RecordTable.module.scss";

const RecordOptions = ({
  row,
  onRecordOptionsclick,
  onRecordDetailsClick,
  onDeleteRecordClick,
  onOverrideRecordClick,
  selectedRecord,
  rowPopOverVisible,
  focussedIdentityTable = false,
  isReviewQueueTable = false,
  isQuarantineView = false,
  isNewQuarantine = false,
  isInvisible = false
}) => {
  return (
    <div>
      <LinkButton icon="menu_hidden" onClick={onRecordOptionsclick} />
      <ButtonList
        className={`${styles.outsidebutton} ${
          rowPopOverVisible && selectedRecord === row.original.id
            ? styles.isVisible
            : ""
        }`}
        vertical
        spacing="0.2"
      >
        <LinkButton
          className={styles.insidebutton}
          onClick={onRecordDetailsClick}
        >
          {row.original.isExpanded ? (
            <p>Hide Record Details</p>
          ) : (
            <p>View Record Details</p>
          )}
        </LinkButton>
        {focussedIdentityTable &&
          !isReviewQueueTable &&
          !isInvisible &&
          !isNewQuarantine && (
            <LinkButton
              className={styles.insidebutton}
              onClick={onOverrideRecordClick}
            >
              Override Record
            </LinkButton>
          )}
        {focussedIdentityTable &&
          !isReviewQueueTable &&
          !isInvisible &&
          !isNewQuarantine && (
            <LinkButton
              className={styles.insidebutton}
              onClick={onDeleteRecordClick}
            >
              Delete Record
            </LinkButton>
          )}
      </ButtonList>
    </div>
  );
};

export default RecordOptions;
